import { Helpers } from '../../helpers';
import { IAssetSuperType } from '../../interfaces/iasset-super-type';
import { AssetMappingConfiguration } from '../asset-mapping-configuration';
import { AssetType } from '../asset-type';

export class AssetSuperTypeBase {
  AssetSuperTypeId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  AssetMappingConfigurations_AssetSuperType?: Array<AssetMappingConfiguration> | null;
  AssetTypes_AssetSuperType?: Array<AssetType> | null;

  constructor(item?: IAssetSuperType) {
    if (item) {

      this.AssetSuperTypeId = item.AssetSuperTypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.AssetMappingConfigurations_AssetSuperType = Helpers.createClassArray(AssetMappingConfiguration, item.AssetMappingConfigurations_AssetSuperType);
      this.AssetTypes_AssetSuperType = Helpers.createClassArray(AssetType, item.AssetTypes_AssetSuperType);
    }
  }
}